import { GO_NEXT, CLOSE } from 'ha/modules/ActivationModal/actions';

export const initialState = 0;

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GO_NEXT:
      return state + 1;

    case CLOSE:
      return 0;

    default:
      return state;
  }
};

export default reducer;
